import * as React from "react";
import { getI18NKey } from "../commons/model/HealthIssue";
import { HealthHistoryInfo } from "../patient-portal/HealthHistoryInfo";
import LabelledDataForm from "../label/LabelledDataForm";

export default function HealthHistoryInformationItemsList({
  healthHistoryInfo,
}: {
  healthHistoryInfo: HealthHistoryInfo;
}) {
  return (
    <LabelledDataForm
      data={[
        {
          label: i18n["Page.Portal.HealthHistoryInformation.HealthIssues.Title"],
          value:
            healthHistoryInfo.healthIssues?.map((it) => i18n[getI18NKey(it)]).join(", ") ||
            undefined,
        },
        {
          label: i18n["Page.Portal.HealthHistoryInformation.CurrentMedications.Title"],
          value: healthHistoryInfo.currentMedications,
        },
        {
          label: i18n["Page.Portal.HealthHistoryInformation.DrugAllergies.Title"],
          value: healthHistoryInfo.drugAllergies,
        },
        {
          label: i18n["Page.Portal.HealthHistoryInformation.TakenOsteoporosisMedications.Title"],
          value: healthHistoryInfo.takenOsteoporosisMedications
            ? i18n["Global.Yes"]
            : i18n["Global.No"],
        },
        {
          label: i18n["Page.Portal.HealthHistoryInformation.AdditionalHealthInformation.Title"],
          value: healthHistoryInfo.additionalHealthInformation,
        },
      ]}
    />
  );
}
